import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ListeaUsuariosCalificaciones from "./ListeaUsuariosCalificaciones";
import socket from "../tools/socke";

const UsuarioBuscador = ({ devuelvo, criterio }) => {
  const [listadoPromocion, setListadoPromocion] = useState([]);
  const [visible, setVisible] = useState(false);
  const [cadetesFiltrados, setCadetesFiltrados] = useState([]);
  const [filtro, setFiltro] = useState("");
  const inputRef = useRef(null); // Referencia para el input

  // Enfocar el input al montar el componente
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

 
  const obtieneCadete = async (dato) => {
    try {
      if (dato.length > 2) {
//         console.log(dato)
        const username = process.env.REACT_APP_KEY;
        const password = process.env.REACT_APP_PASS;
        const token = btoa(`${username}:${password}`);

        const response = await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveUsuariosCalificaciones/${dato}`,
           { estado: "activo" },
          {
            headers: {
              Authorization: `Basic ${token}`,
            },
          }
        );

// console.log(response)
        setVisible(true);
        setCadetesFiltrados(response.data.datos || []);
      } else {
        setCadetesFiltrados([]);
      }
    } catch (error) {
    
    }
  };

  // Manejar cambios en el filtro
  const handleInputChange = (e) => {
    const texto = e.target.value;
    setFiltro(texto);
    obtieneCadete(texto);
  };

 
  const enciendeLectores = (va) => {
    setCadetesFiltrados([])
    setFiltro("");
  devuelvo(va)
  };

  return (
    <div>
      <div>
        <input
          ref={inputRef} // Asignar la referencia al input
          type="text"
          placeholder="Buscar usuario"
          value={filtro}
          onChange={handleInputChange}
          style={{
            padding: "10px",
            fontSize: "16px",
            marginBottom: "10px",
            width: "65%",
            boxSizing: "border-box",
            textAlign: "center",
          }}
        />
      </div>
      {visible && cadetesFiltrados.length > 0 && (<>
        <div style={{maxHeight:"300px"}}>
        <ListeaUsuariosCalificaciones
          actualiza={(value) => enciendeLectores(value)}
          items={cadetesFiltrados}
        /></div>
      </>)}
      {visible && cadetesFiltrados.length === 0 &&filtro!="" &&(<>
        <div style={{maxHeight:"300px"}}>
        <h4>No hay usuarios con esos datos</h4></div>
      </>)}
    </div>
  );
};

export default UsuarioBuscador;
